export const resultStatusColor: Record<string, 'error' | 'warning' | 'success' | 'orange' | 'gray'> = {
	success: 'success',
	error: 'error',
	warning: 'warning',
	humanNeeded: 'orange',
	exception: 'gray',
};
